Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTransformStyles;
function getTransformStyles(transformValue) {
  return {
    transform: transformValue,
    msTransform: transformValue,
    MozTransform: transformValue,
    WebkitTransform: transformValue
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-dates/lib/utils/getTransformStyles.js
// module id = 2788
// module chunks = 0